export const QUERY_PARAM = 'QUERY_PARAM';
export const HEADER = 'HEADER';